import type { PaddleConfigModel, SubscriptionModel } from '../Models/SubscriptionModel';
import { http } from './httpService';

export const SubscriptionService = {
  /**
   * The current entitlement, recomputed by the server on every read, so an
   * expiry bites without a scheduler having to run.
   */
  get: () => http.get<SubscriptionModel>('/subscription'),

  /** Publishable configuration only. The webhook secret never leaves the API. */
  paddleConfig: () => http.get<PaddleConfigModel>('/paddle/config'),

  /**
   * Opens Paddle's own portal for payment method, invoices and cancellation.
   * The window has to be opened synchronously from the click, then pointed
   * here when the URL arrives; see WhatsAppUtil.openWhatsAppAfter for the same
   * pattern and the reason.
   */
  portalSession: () => http.post<{ url: string; cancelUrl: string | null; updatePaymentUrl: string | null }>('/paddle/portal')
};
